/**
 * Extracts values for a given key from an array of objects and returns them as a Set.
 * @param arr The array of objects.
 * @param key The key to pluck values from.
 * @returns A Set containing the unique values
 */
export const pluckToSet = <T extends object, K extends keyof T>(
  arr: T[] | null | undefined,
  key: K
) => {
  if (!arr) return new Set([]);

  const values = arr.map((item) => item[key]);

  return new Set(values);
};
